<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-01 14:14:26
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-13 10:50:39
-->
<template>
	<el-select v-bind="$attrs" v-model="curPlatform" :placeholder="placeholder" @change="change">
		<el-option v-for="item in platformList" :key="item.value" :label="item.label" :value="+item.value"></el-option>
	</el-select>
</template>
<script>
import { PLATFORM_LIST } from '@/utils/dataMap';
import { mapGetters } from 'vuex';
export default {
	name: 'PlatformSelect',
	props: {
		value: [String, Number, Array],
		showAll: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: '请选择',
		},
	},
	data() {
		return {
			curPlatform: this.value,
		};
	},
	watch: {
		value(val) {
			this.curPlatform = val;
		},
	},
	computed: {
		...mapGetters(['platformVersion']),
		platformList() {
			const canShowPlatformList = PLATFORM_LIST.filter(item => this.platformVersion.includes(+item.value));
			return this.showAll ? [{ label: '全部平台', value: 0 }, ...canShowPlatformList] : canShowPlatformList;
		},
	},
	methods: {
		change(val) {
			this.curPlatform = val;
			this.$emit('input', +val);
			this.$emit('settingPlatform', +val);
		},
	},
};
</script>